import React__default from 'react';
import Divider from '../Divider/Divider.component.js';
import styles from './Dropdown.module.scss.js';

var DropdownGroup = function (_a) {
    var children = _a.children;
    return (React__default.createElement("div", { className: styles.Group },
        children,
        React__default.createElement(Divider, { className: styles.Group_divider })));
};
DropdownGroup.displayName = 'DropdownGroup';

export { DropdownGroup as default };
